require('./bootstrap');

import 'bootstrap/dist/js/bootstrap';
import './form'
import './brochureModal'
import './knowledgeEventModal'
import './knowledgeEventSlider'
import './covidEventSlider'
import './scripts'
